import { Component, OnDestroy, Signal, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PASSWORD_PATTERN, PASSWORD_MIN_LENGTH } from '../../anagrafiche/User/password.constants';
import { catchError, combineLatest, filter, map, of, Subject, switchMap } from 'rxjs';
import { UserService } from '../../../swagger';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchErrorModalOrEmpty, showError } from '../../../components/error/error.component';
import { ActivatedRoute, Router } from '@angular/router';
import { isString } from 'lodash-es';
import { CommonModule } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-user-password',
  templateUrl: './user-password.component.html',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule]
})
export class UserPasswordComponent implements OnDestroy {
  readonly submit = new Subject<void>();
  // readonly toggle = new Subject<void>();
  readonly otpExists = signal(false);
  readonly notoken: Signal<boolean>;
  readonly passExpiration = signal<Date | null>(null);
  readonly form = new FormGroup(
    {
      currentPassword: new FormControl<string>('', [Validators.required]),
      newPassword: new FormControl<string>('', [Validators.required, Validators.minLength(PASSWORD_MIN_LENGTH), Validators.pattern(PASSWORD_PATTERN)]),
      confirmPassword: new FormControl<string>('', [Validators.required])
    },
    [
      a => {
        const newPassword = a.get('newPassword')?.value;
        const confirmPassword = a.get('confirmPassword')?.value;
        if (newPassword !== confirmPassword) return { passwordMismatch: true };
        const oldPassword = a.get('currentPassword')?.value;
        if (newPassword === oldPassword) return { passwordSameAsOld: true };
        return null;
      }
    ]
  );

  constructor(api: UserService, modal: NgbModal, router: Router, route: ActivatedRoute) {
    const tokenObs = route.paramMap.pipe(map(a => a.get('token') ?? null));
    tokenObs.subscribe(token => {
      if (isString(token) && token.length > 0)
        this.form.get('currentPassword')?.disable();
      else
        this.form.get('currentPassword')?.enable();
    })
    this.notoken = toSignal(tokenObs.pipe(map(a => !isString(a) || a.length === 0)), { initialValue: false });
    combineLatest([tokenObs, this.submit])
      .pipe(
        filter(() => this.form.valid),
        map(([token]) => {
          if (isString(token) && token.length > 0)
            return api.userChangePasswordWithTokenPost(token, this.form.get('newPassword')?.value ?? '');
          return api.userChangeOwnPasswordPost(this.form.get('currentPassword')?.value ?? '', this.form.get('newPassword')?.value ?? '');
        }),
        switchMap(a => a.pipe(catchErrorModalOrEmpty(modal, 'Errore durante il cambio della password', []))),
        switchMap(() => showError(modal, 'Successo', ['Password cambiata con successo.']).pipe(catchError(() => of(void 0))))
      )
      .subscribe(() => router.navigate(['/']));

    // this.toggle
    //   .pipe(
    //     withLatestFrom(tokenObs),
    //     filter(([_, token]) => !isString(token) || token.length === 0),
    //     switchMap(() => (this.otpExists() ? api.revokeOtpAuthenticator() : api.addOtpAuthenticator())),
    //     startWith(void 0),
    //     switchMap(() =>
    //       api.userGet().pipe(
    //         map(a => ({
    //           otpExists: isString(a.otpAuthenticator?.createdAt) ? new Date(a.otpAuthenticator.createdAt) : null,
    //           passExpiration: a.expirationDate ? new Date(a.expirationDate) : null
    //         })),
    //         catchError(() =>
    //           of({
    //             otpExists: null,
    //             passExpiration: null
    //           })
    //         )
    //       )
    //     )
    //   )
    //   .subscribe(({ otpExists, passExpiration }) => {
    //     this.otpExists.set(otpExists !== null);
    //     this.passExpiration.set(passExpiration);
    //   });
  }
  ngOnDestroy(): void {
    // this.toggle.complete();
    this.submit.complete();
  }
}
